export default function Availability() {
  return (
    <section id="availability" className="section">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Descarga Nuestras Aplicaciones</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            Explora y descarga nuestras aplicaciones móviles innovadoras. Cada app está optimizada para ofrecer la mejor experiencia en tu dispositivo Android.
          </p>
        </div>

        <div className="grid grid-2" style={{ gap: 'var(--spacing-3xl)' }}>
          {/* App 1: Ascensos App Vortex */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/imagenes/ascensos app vortex.png" alt="Ascensos App Vortex" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Ascensos App Vortex</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Sistema integral de educación para la Marina de México con IA.
            </p>
            <a href="#contact" className="btn btn-primary">Disponible próximamente</a>
          </div>

          {/* App 2: Vortex Texto - Audio */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/imagenes/vortex texto a audios.png" alt="Vortex Texto - Audio" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Vortex Texto - Audio</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Convierte textos en audios de alta calidad.
            </p>
            <a href="#contact" className="btn btn-primary">Disponible próximamente</a>
          </div>

          {/* App 3: Vortex Audio Texto IA */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/imagenes/vortex audio a textos.png" alt="Vortex Audio Texto IA" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Vortex Audio Texto IA</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Transcripción automática de audio a texto con IA.
            </p>
            <a href="#contact" className="btn btn-primary">Disponible próximamente</a>
          </div>

          {/* App 4: Flashcard Vortex */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/imagenes/flashcards.png" alt="Flashcard Vortex" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Flashcard Vortex</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Sistema de tarjetas de estudio inteligente con IA.
            </p>
            <a href="#contact" className="btn btn-primary">Disponible próximamente</a>
          </div>

          {/* App 5: Scout Conecta */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/imagenes/scout conecta.png" alt="Scout Conecta" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Scout Conecta</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Plataforma integral para el movimiento scout mexicano.
            </p>
            <a href="#contact" className="btn btn-primary">Disponible próximamente</a>
          </div>

          {/* App 6: Ascensos App Lite */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/imagenes/ascensos app lite.png" alt="Ascensos App Lite" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Ascensos App Lite</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Versión especializada para exámenes de ascenso.
            </p>
            <a href="#contact" className="btn btn-primary">Disponible próximamente</a>
          </div>

          {/* App 7: Cuentos que enseñan */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/imagenes/cuentos que ensenan.png" alt="Cuentos que enseñan" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Cuentos que enseñan</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Cuentos educativos generados por IA para niños.
            </p>
            <a href="#contact" className="btn btn-primary">Disponible próximamente</a>
          </div>

          {/* Coming Soon */}
          <div style={{
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-2xl)',
            border: '1px solid var(--border)',
            textAlign: 'center'
          }}>
            <img src="/icons/ai.png" alt="Próximas apps" style={{ width: '80px', marginBottom: 'var(--spacing-lg)' }} />
            <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Próximas Apps</h3>
            <p style={{ marginBottom: 'var(--spacing-lg)', color: 'var(--text-secondary)' }}>
              Nuevas aplicaciones innovadoras en desarrollo.
            </p>
            <a href="#contact" className="btn btn-secondary">Regístrate para notificaciones</a>
          </div>
        </div>

        <div style={{
          marginTop: 'var(--spacing-3xl)',
          textAlign: 'center',
          padding: 'var(--spacing-2xl)',
          background: 'var(--bg-tertiary)',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border)'
        }}>
          <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>
            ¿Interesado en nuestras aplicaciones?
          </h3>
          <p style={{ marginBottom: 'var(--spacing-xl)' }}>
            Mantente informado sobre lanzamientos y actualizaciones. Nuestro equipo te notificará cuando tus apps favoritas estén disponibles.
          </p>
          <a href="#contact" className="btn btn-primary">
            Contactar equipo
          </a>
        </div>
      </div>
    </section>
  )
} 